var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`${_vm.capitalizeFirstLetter(_vm.locale)}About`,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }